import { render } from "./EdicionIdiomas.vue?vue&type=template&id=1ecd59b6"
import script from "./EdicionIdiomas.vue?vue&type=script&lang=js"
export * from "./EdicionIdiomas.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__